import { gql, TypedDocumentNode } from "@apollo/client";

export const RECENTLY_VISITED_QUERY_FIRST = 1400;

export type RecentVisitEntityTypeGql =
  | "PEOPLE"
  | "JOBS"
  | "FACILITIES"
  | "SECTIONS"
  | "EVENTS"
  | "ACTIVITIES"
  | "OTHER";

export type RecentlyVisitedQueryVisit = {
  id: string;
  url: string;
  text: string;
  subtext: string;
  image: string;
  visitedAt: string;
  entityType: RecentVisitEntityTypeGql;
  entityId: string;
};

export type RecentlyVisitedQueryResponse = {
  recentlyVisited: RecentlyVisitedQueryVisit[];
};

export type RecentlyVisitedQueryVariables = {
  first: number;
};

export const RECENTLY_VISITED_QUERY: TypedDocumentNode<RecentlyVisitedQueryResponse, RecentlyVisitedQueryVariables> =
  gql`
    query RecentlyVisited($first: Int) {
      recentlyVisited(first: $first) {
        id
        url
        text
        subtext
        image
        visitedAt
        entityType
        entityId
      }
    }
  `;
